import Marketo from "./Marketo.class";

const {jQuery: $} = window;
import Utils from "./utils.class";
import Cookies from 'js-cookie';
import Cookiebot from "./Cookiebot.class";
import PieChartCounter from "./components/PieChartCounter.class";
import ElementorInPageNavWidget from "./components/ElementorInPageNav.class";

export default class Theme {
    $main;
    $html;
    $body;
    $header;
    #config;
    #scrollOffset;
    #scrollSpeed;
    #slider;
    #utils;
    #$admin;
    #root;
    #topBarHeight;
    #cmp;
    #counter;
    #mkto;

    constructor(
        config,
        utils,
        slider
    ) {
        this.#config = config;
        this.#utils = utils;
        this.#scrollOffset = 20;
        this.#root = document.querySelector(":root");
        this.#topBarHeight = 0;

        this.#scrollSpeed = 750;
        this.$html = $('html');

        this.$body = $('body');
        this.$main = $('#site-wrapper');
        this.$header = $('header.elementor-location-header');
        this.#$admin = $('#wpadminbar');
        this.#slider = slider;
        this.#counter = $('.counter__number');

        if (window.location.hash === "#dev") {
            Cookies.set("debug", "1");
        }

        Utils.log("Theme Config:", config);

        this.#cmp = new Cookiebot(this.$body);
        this.#mkto = new Marketo(config.marketoID, config.marketoURL, false, {
            bannedDomains: config.emailBannedDomains,
            freeDomains: config.emailFreeDomains,
            autoValues: [],
            floatLabels: false
        });

        window._wq = window._wq || [];

        this.#cmp.onConsent("marketing", () => {
            // Wistia Consent Integration
            window._wq.push(function (W) {
                W.consent(true);
            });

            // Save UTMs to cookies
            const utms = this.UTMs;

            Cookies.set("utm_id", utms.id, {expires: 30});
            Cookies.set("utm_campaign", utms.campaign, {expires: 30});
            Cookies.set("utm_source", utms.source, {expires: 30});
            Cookies.set("utm_medium", utms.medium, {expires: 30});
            Cookies.set("utm_term", utms.term, {expires: 30});
            Cookies.set("utm_content", utms.content, {expires: 30});

            Utils.log("UTM Data", utms);
        });

        this.#cmp.onDenied("marketing", () => {
            // Wistia Consent Integration
            window._wq.push(function (W) {
                W.consent(false);
            });

            // Removes UTM cookies
            Cookies.remove("utm_id");
            Cookies.remove("utm_campaign");
            Cookies.remove("utm_source");
            Cookies.remove("utm_medium");
            Cookies.remove("utm_term");
            Cookies.remove("utm_content");
        });

        new PieChartCounter(this);
        new ElementorInPageNavWidget(".inPageNav--active nav", this.headerHeight);

        $(window).on("kmdg_marketo_form_loaded", (e, form, data) => this.__formHandler(form, data));
    }

    __onReady() {
        const me = this;
        Utils.log("Theme Ready");
        this.#updateCssHeaderHeight();
        this.#addButtonAccessibleLabels();

        $(window).on('hashchange', function (e) {
            if (location.hash) {
                Utils.log("Scroll to Hash:", location.hash);
                if (Utils.scrollToHash(location.hash, null, me.scrollOffset, me.#scrollSpeed)) {
                    e.preventDefault();
                }
            }
        });

        $(document).on('click', 'a', function (e) {

            let $el = $(this);

            if ($el.attr('href') && $el.attr('href').search('#') === 0) {
                let hash = $el[0].hash;
                Utils.log("Scroll to Link:", hash);

                if (hash === "#open-cmp") {
                    me.CMP.open();
                    e.preventDefault();
                    return false;
                }

                if (Utils.scrollToHash(hash, null, me.scrollOffset, me.#scrollSpeed)) {
                    e.preventDefault();
                }
            }
        });

        $('a').each(function (i, el) {
            const url = $(el).attr("href");
            // use url.indexOf() to look for youtube embed urls
            // apply featherlight on those tags, unless explicitly opted out
            if (url && $(el).attr("data-no-lightbox") === undefined) {
                if (url.indexOf("youtube.com/watch?v=") >= 0 || url.indexOf("youtu.be/") >= 0 || (url.indexOf("youtube.com/embed/") >= 0)) {
                    const id = Utils.youtubeParser(url);
                    $(el).attr("data-featherlight", "iframe")
                        .attr("data-featherlight-iframe-width", "850")
                        .attr("data-featherlight-iframe-height", "468")
                        .attr("data-featherlight-iframe-frameborder", "0")
                        .attr("data-featherlight-iframe-allow", "autoplay; encrypted-media")
                        .attr("data-featherlight-iframe-allow", "autoplay; encrypted-media")
                        .attr("data-featherlight-iframe-allowfullscreen", "true")
                        .attr("href", "https://www.youtube.com/embed/" + id + "?rel=0&amp;autoplay=1");

                    $(el).featherlight();
                }
            }
        });


        $("img[data-fallback]").on('error', function () {
            const $img = $(this);
            const fallback = $img.data("fallback");
            $img.removeAttr("data-fallback");
            if (fallback) {
                $img.attr("src", fallback);
            }
        });

        const $catalystNav = $(".catalystLab__nav");
        if ($catalystNav.length && "IntersectionObserver" in window) {
            const sections = $catalystNav.find(".catalystLab__navLink[href^='#']")
                .filter(function () {
                    return this.getAttribute("href").length > 1;
                })
                .get()
                .reduce(function (acc, link) {
                    const section = document.getElementById(link.getAttribute("href").slice(1));
                    if (section) {
                        acc.push({section: section, $link: $(link)});
                    }
                    return acc;
                }, []);

            if (sections.length) {
                const setActiveSection = function (id) {
                    sections.forEach(function (entry) {
                        entry.$link.toggleClass("catalystLab__navLink--active", entry.section.id === id);
                    });
                };

                const navSpy = new IntersectionObserver(function (entries) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) {
                            setActiveSection(entry.target.id);
                        }
                    });
                }, {
                    rootMargin: "-" + ($catalystNav.outerHeight() + me.headerHeight + 20) + "px 0px -70% 0px",
                    threshold: 0
                });

                sections.forEach(function (entry) {
                    navSpy.observe(entry.section);
                });
            }
        }

        $(".kpf-slider-mode").each(function (i, el) {
            const $el = $(el);
            const $arrowToggle = $el.data("arrows");
            const $dotToggle = $el.data("dots");
            const $speed = $el.data("speed");
            const $mobileSpeed = $el.data("mobile-speed");
            const $cycle = $el.data("cycle");
            const $tiles = $el.data("tiles");
            const $tilescroll = $el.data("tilescroll");
            const $rightArrow = '<i class="fa fas fa-chevron-right" />';
            const $leftArrow = '<i class="fa fas fa-chevron-left" />';
            // $el.css({'visibility': 'visible'});
            let $responsiveTiles;
            switch ($tiles) {
                case 3:
                    $responsiveTiles = 2;
                    break;
                case 2:
                    $responsiveTiles = 2;
                    break;
                case 1:
                    $responsiveTiles = 1;
                    break;
                default:
                    $responsiveTiles = 2;
                    break;
            }

            $el.find(".kpfsc__posts").slick({
                arrows: $arrowToggle,
                prevArrow: `<button type="button" class="slick-prev slick-custom-prev"> ${$leftArrow} </button>`,
                nextArrow: `<button type="button" class="slick-next slick-custom-next"> ${$rightArrow} </button>`,
                autoplay: $cycle,
                autoplaySpeed: $speed,
                pauseOnFocus: true,
                pauseOnHover: true,
                autoHeight: "calc",
                dots: $dotToggle,
                adaptiveHeight: false,
                infinite: true,
                slidesToScroll: $tilescroll,
                slidesToShow: $tiles,
                swipeToSlide: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: $responsiveTiles,
                        }
                    },
                    {
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 1,
                            autoplaySpeed: $mobileSpeed,
                        }
                    }
                ]
            });
        });

        $(".rcioFilterBar__filter select[name='resource-location']").on('change', function () {
            window.location.href = $(this).val();
        });

        this.#setupSearch();

        const animatePicker = function (entries, observer) {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    let el = entry.target;
                    if (entry.intersectionRatio >= 0.75) {
                        $(el).trigger("builderAnimationStart", [el]);
                    }
                }
            });

        }

        const $components = $(".elementor-widget-ticker-counter-wrap");
        const options = {
            root: null,
            rootMargin: "0px",
            scrollMargin: "-30% 0px -30% 0px",
            threshold: 1.0,
        };
        const observer = new IntersectionObserver((entries, observer) => animatePicker(entries, observer), options);

        $components.each(function (i, el) {
            observer.observe(el);
        });

        //Accordion JS
        $('.catalystLab__singleAccordion .catalystLab__accordionHeader').on('click', function () {
            var $column = $(this).parent();

            $column.toggleClass('open');
            $column.find('.catalystLab__accordionInner').slideToggle({
                duration: 250,
                progress: function () {
                    $(window).trigger('resize');
                }
            });
        });

        // $('.catalystLab__accordionHeader').on('click', function () {
        //     var $clicked = $(this);
        //     var $column = $(this).parent();
        //
        //     $('.single_accordion').each(function (index, element) {
        //         if ($(this).hasClass('open') && $(this).data('row') !== $column.data('row')) {
        //             $(this).toggleClass('open');
        //             $(this).find('.catalystLab__accordionInner').slideToggle({
        //                 duration: 250,
        //                 progress: function () {
        //                     $(window).trigger('resize');
        //                 }
        //             });
        //         }
        //     })
        //
        //     $column.toggleClass('open');
        //     $column.find('.catalystLab__accordionInner').slideToggle({
        //         duration: 250,
        //         progress: function () {
        //             $(window).trigger('resize');
        //         }
        //     });
        // });

    }

    __onLoad() {
        const me = this;

        Utils.log("Theme Load");

        this.#updateCssHeaderHeight();

        this.$header.addClass('fixed');
        $(window).trigger("resize");

        if (location.hash) {
            Utils.log("Scroll to Section Load");

            setTimeout(function () {
                Utils.scrollToHash(location.hash, null, me.scrollOffset, me.#scrollSpeed);

            }, 300);
        }

        $('.search-bar .search-button').on('click', function () {
            $(this).parent().toggleClass('open');
        });

        const top = 1; // Trigger on any scrolling
        const hideAfter = 10; // px of downward travel before the top bar slides away
        const revealAfter = 60; // px of *deliberate* upward travel before it comes back
        let lastScrollPos = Math.max(0, $(document).scrollTop());
        let anchorPos = lastScrollPos;
        let lastDirection = 0; // 1 = down, -1 = up
        let ticking = false;

        const onScroll = function () {
            ticking = false;

            // Clamp so iOS rubber-band overscroll can't read as an upward scroll.
            const scrollPos = Math.max(0, $(document).scrollTop());

            if (top && scrollPos >= top) {
                me.$header.addClass('scrolled');
            } else if (top && scrollPos < top) {
                me.$header.removeClass('scrolled');
            }

            // Top bar is absent, measures 0 (hidden on mobile), or the header
            // isn't fixed on this page/context, so there's nothing to slide away.
            if (!me.#canScrollHide()) {
                me.#setHeaderCollapsed(false);
                lastScrollPos = anchorPos = scrollPos;
                lastDirection = 0;

                return;
            }

            // Always show the top bar while it would still be on screen anyway.
            if (scrollPos <= me.#topBarHeight) {
                me.#setHeaderCollapsed(false);
                lastScrollPos = anchorPos = scrollPos;
                lastDirection = 0;

                return;
            }

            const direction = scrollPos > lastScrollPos ? 1 : (scrollPos < lastScrollPos ? -1 : 0);

            // On a reversal, start measuring travel from the point where it turned
            // around. Momentum settling and Chrome's scroll anchoring (lazy-loaded
            // images resizing above the viewport) both nudge the page up by a few
            // pixels, and neither should count as "the user scrolled back up".
            if (direction !== 0 && direction !== lastDirection) {
                anchorPos = lastScrollPos;
                lastDirection = direction;
            }

            const travel = scrollPos - anchorPos;

            if (travel > hideAfter) {
                me.#setHeaderCollapsed(true);
            } else if (travel < -revealAfter) {
                me.#setHeaderCollapsed(false);
            }

            lastScrollPos = scrollPos;
        };

        $(document).scroll(function () {
            if (!ticking) {
                ticking = true;
                window.requestAnimationFrame(onScroll);
            }
        });

        if ($("#menu-wrapper").length > 0) {
            const menu = new window.Mmenu("#menu-wrapper", {
                "offCanvas": {
                    "position": "right-front"
                },
                "theme": "light-contrast",

                "navbars": [
                    {
                        "position": "bottom",
                        "content": [
                            "searchfield"
                        ]
                    },
                    {
                        "position": "top",
                        "content": [
                            "prev",
                            "title"
                        ]
                    },
                ]
            }, {
                offCanvas: {
                    "page": {
                        "selector": "#site-wrapper"
                    }
                }
            });

            $('.mmenu-nav').on('click', function (evnt) {
                evnt.preventDefault();
                menu.API.open()
            });
        }

        //Preserve UTM codes across site browsing
        let utmParams = {};
        const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
        let utmString = '';
        utmKeys.forEach(key => {
            if (Utils.URLSearchParams.has(key)) {
                utmParams[key] = encodeURIComponent(Utils.URLSearchParams.get(key) || "");
                utmString += `&${key}=${utmParams[key]}`;
            }
        });

        if (Object.keys(utmParams).length > 0) {
            $("a").each(function (e) {
                let $el = $(this);
                if (location.host === $el[0].host && $el[0].hash === '') {
                    if ($el[0].search) {
                        $el.attr("href", `${$el.attr('href')}${utmString}`);
                    } else {
                        $el.attr("href", `${$el.attr('href')}${utmString.replace('&', '?')}`);
                    }
                }
            });
        }

        // Fix SVG's with embedded clip-paths
        $("svg").each(function (i, el) {
            const $el = $(el);
            const $parent = $el.closest(".elementor-widget");
            let pathIDs = [];
            const suffix = $parent.data("id");
            const instance = i;

            $el.find("clipPath").each((i, el) => {
                const $cp = $(el);
                let id = $cp.attr("id");
                pathIDs.push(id);
                $cp.attr("id", `${id}-${suffix}-${instance}`);
            });

            pathIDs.forEach((val, key) => {
                $el.find(`[clip-path="url(#${val})"]`).each((i, el) => {
                    const $cpEL = $(el);
                    $cpEL.attr("clip-path", `url(#${val}-${suffix}-${instance})`);
                });
            });
        });

        $('.js--hide-while-loading').removeClass('js--hide-while-loading');

        $('.kmdgTR').each(function (i, el) {
            const $el = $(el);
            const origin = window.location.origin + '/wp-json/hgi/testimonials';
            const dataSettings = JSON.parse($el.attr('data-settings'));
            const postNumber = dataSettings.post_count ? dataSettings.post_count : '10';
            const apiUrl = dataSettings.review_type === 'all' ? '/' : (dataSettings.review_type === 'known' ? '/known' : '/random/?limit=' + postNumber);
            const fullStar = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M341.5 45.1C337.4 37.1 329.1 32 320.1 32C311.1 32 302.8 37.1 298.7 45.1L225.1 189.3L65.2 214.7C56.3 216.1 48.9 222.4 46.1 231C43.3 239.6 45.6 249 51.9 255.4L166.3 369.9L141.1 529.8C139.7 538.7 143.4 547.7 150.7 553C158 558.3 167.6 559.1 175.7 555L320.1 481.6L464.4 555C472.4 559.1 482.1 558.3 489.4 553C496.7 547.7 500.4 538.8 499 529.8L473.7 369.9L588.1 255.4C594.5 249 596.7 239.6 593.9 231C591.1 222.4 583.8 216.1 574.8 214.7L415 189.3L341.5 45.1z"/></svg>`;
            const halfStar = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M320.1 417.6C330.1 417.6 340 419.9 349.1 424.6L423.5 462.5L410.5 380C407.3 359.8 414 339.3 428.4 324.8L487.4 265.7L404.9 252.6C384.7 249.4 367.2 236.7 357.9 218.5L319.9 144.1L319.9 417.7zM489.4 553C482.1 558.3 472.4 559.1 464.4 555L320.1 481.6L175.8 555C167.8 559.1 158.1 558.3 150.8 553C143.5 547.7 139.8 538.8 141.2 529.8L166.4 369.9L52 255.4C45.6 249 43.4 239.6 46.2 231C49 222.4 56.3 216.1 65.3 214.7L225.2 189.3L298.8 45.1C302.9 37.1 311.2 32 320.2 32C329.2 32 337.5 37.1 341.6 45.1L415 189.3L574.9 214.7C583.8 216.1 591.2 222.4 594 231C596.8 239.6 594.5 249 588.2 255.4L473.7 369.9L499 529.8C500.4 538.7 496.7 547.7 489.4 553z"/></svg>`;
            const emptyStar = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M320.1 32C329.1 32 337.4 37.1 341.5 45.1L415 189.3L574.9 214.7C583.8 216.1 591.2 222.4 594 231C596.8 239.6 594.5 249 588.2 255.4L473.7 369.9L499 529.8C500.4 538.7 496.7 547.7 489.4 553C482.1 558.3 472.4 559.1 464.4 555L320.1 481.6L175.8 555C167.8 559.1 158.1 558.3 150.8 553C143.5 547.7 139.8 538.8 141.2 529.8L166.4 369.9L52 255.4C45.6 249 43.4 239.6 46.2 231C49 222.4 56.3 216.1 65.3 214.7L225.2 189.3L298.8 45.1C302.9 37.1 311.2 32 320.2 32zM320.1 108.8L262.3 222C258.8 228.8 252.3 233.6 244.7 234.8L119.2 254.8L209 344.7C214.4 350.1 216.9 357.8 215.7 365.4L195.9 490.9L309.2 433.3C316 429.8 324.1 429.8 331 433.3L444.3 490.9L424.5 365.4C423.3 357.8 425.8 350.1 431.2 344.7L521 254.8L395.5 234.8C387.9 233.6 381.4 228.8 377.9 222L320.1 108.8z"/></svg>`;
            $.ajax(`${origin}${apiUrl}`, {data: 'json', method: 'get'}).done((response) => {
                const testimonialResponse = response.testimonials;
                let reviewHTML = '';

                for (let i = 0; i < postNumber; i++) {
                    let block = Object.values(testimonialResponse)[i];
                    const dateObj = new Date(block.review.publishedDate);
                    const date = dateObj.toLocaleDateString('en-US');
                    let starPrint;
                    const starRemainder = 10 - block.review.rating;
                    switch (true) {
                        case (starRemainder === 5):
                            starPrint = fullStar.repeat(2) + halfStar + emptyStar + emptyStar;
                            break;
                        case (starRemainder === 4):
                            starPrint = fullStar.repeat(3) + emptyStar + emptyStar;
                            break;
                        case (starRemainder === 3):
                            starPrint = fullStar.repeat(3) + halfStar + emptyStar;
                            break;
                        case (starRemainder === 2):
                            starPrint = fullStar.repeat(4) + emptyStar;
                            break;
                        case (starRemainder === 1):
                            starPrint = fullStar.repeat(4) + halfStar;
                            break;
                        default:
                            starPrint = fullStar.repeat(5);
                    }
                    // Detail List potentially to be added.
                    // <div className="kmdgTR__detailwrap">
                    //     // <div className="kmdgTR__anon">${block.isAnonymous}</div>
                    //     // <div className="kmdgTR__incentivized">${block.Incentivized}</div>
                    //     // <div className="kmdgTR__incentivized--source">${block.IncentiveSource}</div>
                    //     // <div className="kmdgTR__promoted">${block.taggedreviewStatus}</div>
                    // </div>

                    reviewHTML += `
                    <div class="slide_wrap">
                    <div class="kmdgTR__review">
                        <div class="kmdgTR__testimonial">
                            <h3 class="kmdgTR__title">${block.review.heading}</h3>
                                <div class="kmdgTR__starwrap">
                                    <div class="kmdgTR__star">${starPrint}</div>
                                    <div>(${block.review.rating})</div>
                                    <div class="kmdgTR__date">-${date}</div>
                                </div>
                            <div class="kmdgTR__text">
                                 ${block.text}
                            </div>
                            <a href="${block.review.url}" target="_blank" class="kmdgTR__url">Read the full HG Insights review</a>
                        </div>
                        <div class="kmdgTR__user">
                            <div class="kmdgTR__picture">
                                <img src="${block.user.pictureUrl ?? '/wp-content/uploads/2025/08/placeholder_person.webp'}" alt="" width="75" height="75">
                            </div>
                            <div class="kmdgTR__name">${block.user.name}</div>
                            <div class="kmdgTR__position">
                                <div class="kmdgTR__position--title">${block.user.position.title || ''}</div>
                                <div class="kmdgTR__position--jobtype">${block.user.position.jobType || ''}</div>
                                <div class="kmdgTR__position--department">${block.user.position.departmnet || ''}</div>
                             </div>
                            <div class="kmdgTR__company">
                                <div class="kmdgTR__company--industry">${block.user.company.industry.name || ''}</div>
                                <div class="kmdgTR__company--name">${block.user.company.name || ''}</div>
                                <div class="kmdgTR__company--size">${block.user.company.size || ''}</div>
                            </div>
                        </div>
                    </div></div>
                `
                }
                let containerHTML = `
                <div class="kmdgTR__container">
                    ${reviewHTML}
                </div>
                `
                $el.append(containerHTML);

                Utils.equalHeight('.kmdgTR__review', '.kmdgTR__container');

                const $rightArrow = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><!--!Font Awesome Free v6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path fill="#005198" d="M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z"/></svg>'
                const $leftArrow = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><!--!Font Awesome Free v6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path fill="#005198" d="M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z"/></svg>'

                $el.find(".kmdgTR__container").slick({
                    arrows: true,
                    prevArrow: `<div class="slick-prev slick-custom-prev"> ${$leftArrow} </div>`,
                    nextArrow: `<div class="slick-next slick-custom-next"> ${$rightArrow} </div>`,
                    autoplay: false,
                    autoHeight: "calc",
                    dots: false,
                    adaptiveHeight: true,
                    infinite: true,
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    swipeToSlide: true,
                });

            })
        })

    }

    __onResize() {
        this.#updateCssHeaderHeight();
    }

    /**
     * @param {PostFilters} kpf
     * @public
     */
    __postFilters(kpf) {
        Utils.log("Theme customizations for Post Filters...");
        kpf.addFilter('post_transition_delay', () => 0)

        const taxonomies = {
            "role": "role",
            "category": "category",
            "partner-type": "partner-type",
            "integrations-product": "products"
        };

        for (let tax in taxonomies) {
            const slug = taxonomies[tax];
            const pattern = new RegExp("^#/.*" + slug + "/(?<term>[a-z-]*)/?");

            if (window.location.hash.includes(slug)) {
                const match = window.location.hash.match(pattern);


                if (match) {
                    const term = match.groups.term || null;

                    Utils.log(`Found ${tax} hash:`, term);

                    if (term) {
                        kpf.clearHistory();

                        kpf.addFilter("default_settings", (settings, el) => {
                            if (settings.filterData.includes(tax)
                                && settings.filterSelected[tax] == null
                                && this.#config.taxonomies[tax][term]
                            ) {
                                settings.filterSelected[tax] = this.#config.taxonomies[tax][term];
                            }

                            return settings;
                        });
                        Utils.scrollToHash('kpfscroll');
                    }
                }
            }

            $(window).on("hashchange", () => {
                if (window.location.hash.includes(slug)) {
                    const match = window.location.hash.match(pattern);

                    if (match) {
                        const term = match.groups.term || null;

                        Utils.log(`Found ${tax} hash:`, term);

                        if (term && this.#config.taxonomies[tax][term]) {
                            kpf.$el.find(`.kpfsc__filter select[name='${tax}']`).val(this.#config.taxonomies[tax][term]).trigger("change");
                        }
                    }
                }
            });
        }


        for (let tax in taxonomies) {
            const slug = taxonomies[tax];
            const pattern = new RegExp("^#/.*" + slug + "/(?<term>[a-z-]*)/?");

            if (window.location.hash.includes(slug)) {
                const match = window.location.hash.match(pattern);


                if (match) {
                    const term = match.groups.term || null;

                    Utils.log(`Found ${tax} hash:`, term);

                    if (term) {
                        kpf.clearHistory();

                        kpf.addFilter("default_settings", (settings, el) => {
                            if (settings.filterData.includes(tax)
                                && settings.filterSelected[tax] == null
                                && this.#config.taxonomies[tax][term]
                            ) {
                                settings.filterSelected[tax] = this.#config.taxonomies[tax][term];
                            }

                            return settings;
                        });
                        Utils.scrollToHash('kpfscroll');
                    }
                }
            }

            $(window).on("hashchange", () => {
                if (window.location.hash.includes(slug)) {
                    const match = window.location.hash.match(pattern);

                    if (match) {
                        const term = match.groups.term || null;

                        Utils.log(`Found ${tax} hash:`, term);

                        if (term && this.#config.taxonomies[tax][term]) {
                            kpf.$el.find(`.kpfsc__filter select[name='${tax}']`).val(this.#config.taxonomies[tax][term]).trigger("change");
                        }
                    }
                }
            });
        }

        // Catalyst episode badges ("Episode N: Podcast"/"Episode N: Blog") link to "#/episode/N" - numeric, so
        // it needs its own pattern rather than the taxonomies' `[a-z-]*` slug regex above.
        const episodePattern = /^#\/.*episode\/(?<episode>[0-9]+)\/?/;

        if (window.location.hash.includes('episode')) {
            const match = window.location.hash.match(episodePattern);

            if (match) {
                const episode = match.groups.episode || null;

                Utils.log("Found episode hash:", episode);

                if (episode) {
                    kpf.clearHistory();

                    kpf.addFilter("default_settings", (settings, el) => {
                        if (settings.filterData.some((entry) => entry.includes('episode'))
                            && settings.filterSelected['catalyst-episode-number'] == null
                        ) {
                            settings.filterSelected['catalyst-episode-number'] = episode;
                        }

                        return settings;
                    });
                    Utils.scrollToHash('kpfscroll');
                }
            }
        }

        $(window).on("hashchange", () => {
            if (window.location.hash.includes('episode')) {
                const match = window.location.hash.match(episodePattern);

                if (match) {
                    const episode = match.groups.episode || null;

                    Utils.log("Found episode hash:", episode);

                    if (episode) {
                        kpf.$el.find(`.kpfsc__filter select[name='catalyst-episode-number']`).val(episode).trigger("change");
                    }
                }
            }
        });

        kpf.addFilter("select2_options", (opts) => {
            opts.dropdownParent = $("#site-wrapper");
            return opts;
        });

        kpf.addFilter("scroll_offset", () => this.scrollOffset * -1);

        kpf.$el.parent().filter(".kpf-slider-mode").each(function (i, el) {
            const $el = $(el);
            const $arrowToggle = $el.data("arrows");
            const $dotToggle = $el.data("dots");
            const $speed = $el.data("speed");
            const $mobileSpeed = $el.data("mobile-speed");
            const $cycle = $el.data("cycle");
            const $tiles = $el.data("tiles");
            const $rightArrow = '<i class="fa fas fa-chevron-right" />'
            const $leftArrow = '<i class="fa fas fa-chevron-left" />'
            $el.find(".kpfsc__posts").slick({
                arrows: $arrowToggle,
                prevArrow: `<button type="button" class="slick-prev slick-custom-prev"> ${$leftArrow} </button>`,
                nextArrow: `<button type="button" class="slick-next slick-custom-next"> ${$rightArrow} </button>`,
                autoplay: $cycle,
                autoplaySpeed: $speed,
                pauseOnFocus: true,
                pauseOnHover: true,
                autoHeight: "calc",
                dots: $dotToggle,
                adaptiveHeight: true,
                infinite: true,
                slidesToScroll: 1,
                slidesToShow: $tiles,
                swipeToSlide: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 1,
                            autoplaySpeed: $mobileSpeed,
                        }
                    }
                ]
            });
        });

    }

    __formHandler(form, data) {
        // Set up custom marketo integration.

        try {
            // Attempt to fill hidden field with resource data
            form.setValues({'assetTitle': data.name});
            form.setValues({'assetURL': data.url});
            form.setValues({'assetType': data.resourceType.name});

            // Populate UTM values
            form.setValues({'utm_campaign': this.UTMs.campaign});
            form.setValues({'utm_source': this.UTMs.source});
            form.setValues({'utm_medium': this.UTMs.medium});
            form.setValues({'utm_term': this.UTMs.term});
            form.setValues({'utm_content': this.UTMs.content});
            form.setValues({'utm_id': this.UTMs.id});
            form.setValues({'utm_campaign__c': this.UTMs.campaign});
            form.setValues({'utm_source__c': this.UTMs.source});
            form.setValues({'utm_medium__c': this.UTMs.medium});
            form.setValues({'utm_term__c': this.UTMs.term});
            form.setValues({'utm_content__c': this.UTMs.content});
            form.setValues({'utm_id__c': this.UTMs.id});
        } catch (e) {
            Utils.log("Failed to fill form values.");
        }

        if (data.btnText) {
            form.getFormElem().find('button[type="submit"]').text(data.btnText);
        }

        if (data.hasDownload) {
            $.getJSON(kmdgResourceCenter.restURL + `key?resource=${data.id}&checksum=${data.checksum}`, (response) => {
                data.key = response.key;
            });
        }

        form.onSuccess(() => {
            Utils.log("Submitting...");
            let thanks = false;
            let redirect = false;
            const vals = form.getValues();
            const $form = form.getFormElem();

            window.dataLayer = window.dataLayer || [];

            Utils.log("Analytics: Logging Form Fill");

            const event = {
                event: "mktoLead",
                mktoFormId: form.getId(),
                email: vals.Email || "",
                pageURL: window.location.origin + window.location.pathname,
                contentType: data.postType,
                contentSubType: data.resourceType.name,
                contentTitle: data.name,
                contentSlug: data.slug,
                contentID: data.id,
                utm_campaign: this.UTMs.campaign,
                utm_source: this.UTMs.source,
                utm_medium: this.UTMs.medium,
                utm_term: this.UTMs.term,
                utm_content: this.UTMs.content,
                utm_id: this.UTMs.id
            };

            Utils.log("DataLayer Event:", event);
            window.dataLayer.push(event);

            if (data.isResource) {
                // Hand off to RCIO

                $(window).trigger('rcio_form_submitted', [vals.Email || "", data.id, (response) => {
                    $form.html(response);
                }]);
            } else {
                // Integration with page builders

                if (data.thanks) {
                    thanks = $('<textarea/>').html(data.thanks).text();
                }

                if (data.redirectUrl) {
                    redirect = data.redirectUrl;
                }

                if (!thanks && !redirect) {
                    thanks = "<p>Thank you, your submission was received!</p>";
                }

                if (thanks) {
                    Utils.log("Saying thanks...");

                    $form.html("<div class='rcioForm__response rcioForm__response--success'>" + thanks + "</div>");

                    if (redirect) {
                        Utils.log("Redirecting in 2s...")
                        setTimeout(function () {
                            window.location.href = redirect;
                        }, 2000);
                    }

                    return false;
                } else if (redirect) {
                    Utils.log("Redirecting...");

                    setTimeout(function () {
                        window.location.href = redirect;
                    }, 10);
                }
            }

            return false;
        });
    }

    activatePlayer() {
        // TODO: Implement video platform integration
    }

    get utils() {
        return Utils;
    }

    get headerHeight() {
        if (this.#$admin.length > 0) {
            return this.$header.outerHeight() + this.#$admin.outerHeight();
        }

        return this.$header.outerHeight();
    }

    get scrollOffset() {
        let subNav = 0;

        return this.#scrollOffset + this.headerHeight + subNav;
    }

    #setupSearch() {
        function toggleClassForEls(els, theClass) {
            els.forEach((item) => {
                item.classList.toggle(theClass);
            });
        }

        const searchIcon = document.querySelectorAll('.search-menu-icon');
        const searchIconClose = document.querySelectorAll('.search-menu-icon-close');
        const searchBox = document.querySelector('#search-menu-box');

        searchIcon.forEach((item) => {
            item.addEventListener('click', () => {
                const mobileToggle = document.querySelector('.mobile-menu .elementor-menu-toggle')

                if (mobileToggle && mobileToggle.classList.contains('elementor-active')) {
                    document.querySelector('.mobile-menu .elementor-menu-toggle').click();
                }

                searchBox.classList.toggle('isvisible');
                toggleClassForEls(searchIcon, 'isvisible');
                toggleClassForEls(searchIconClose, 'isvisible');
                document.querySelector('.elementor-search-form__input').focus();
            })
        });

        searchIconClose.forEach((item) => {
            item.addEventListener('click', () => {
                searchBox.classList.toggle('isvisible');
                toggleClassForEls(searchIcon, 'isvisible');
                toggleClassForEls(searchIconClose, 'isvisible');
                document.querySelector('.elementor-search-form__input').blur();
            })
        });
    }

    get CMP() {
        return this.#cmp;
    }

    get UTMs() {
        return {
            id: encodeURIComponent(Utils.URLSearchParams.get('utm_id') || Cookies.get("utm_id") || ""),
            campaign: encodeURIComponent(Utils.URLSearchParams.get('utm_campaign') || Cookies.get("utm_campaign") || ""),
            source: encodeURIComponent(Utils.URLSearchParams.get('utm_source') || Cookies.get("utm_source") || ""),
            medium: encodeURIComponent(Utils.URLSearchParams.get('utm_medium') || Cookies.get("utm_medium") || ""),
            term: encodeURIComponent(Utils.URLSearchParams.get('utm_term') || Cookies.get("utm_term") || ""),
            content: encodeURIComponent(Utils.URLSearchParams.get('utm_content') || Cookies.get("utm_content") || ""),
            GCLID: encodeURIComponent(Cookies.get("gclid") || "")
        };
    }

    // Elementor's core Button widget doesn't expose an accessible-name/aria-label field, so
    // generic CTAs across the site ("Learn More", "Read More", etc.) all share the exact same
    // accessible name with no indication of what each one actually leads to. Each button is its
    // own individually-configured widget instance scattered across dozens of sections, not a
    // shared template, so there's no single file to patch - this derives a contextual label at
    // runtime instead, using whatever heading/title text appears in the same card/section.
    #addButtonAccessibleLabels() {
        const genericLabels = ['learn more', 'read more', 'view more', 'find out more', 'discover more'];

        document.querySelectorAll('a.elementor-button').forEach((link) => {
            if (link.hasAttribute('aria-label')) {
                return;
            }

            const text = link.textContent.trim().toLowerCase();
            if (!genericLabels.includes(text)) {
                return;
            }

            // Widget boundaries alone are too narrow - a button's own immediate wrapper rarely
            // contains the card's heading as a descendant, they're siblings further up. Walk up
            // level by level and use whichever ancestor is the first to contain a heading.
            const headingSelector = '.elementor-heading-title, h1, h2, h3, h4, h5, h6';
            let ancestor = link.parentElement;
            let heading = null;
            for (let depth = 0; depth < 8 && ancestor && ancestor !== document.body; depth++) {
                heading = ancestor.querySelector(headingSelector);
                if (heading && heading.textContent.trim()) {
                    break;
                }
                heading = null;
                ancestor = ancestor.parentElement;
            }

            if (heading) {
                link.setAttribute('aria-label', `${link.textContent.trim()} - ${heading.textContent.trim()}`);
            }
        });
    }

    /**
     * The header only slides up when it's actually fixed and the top bar is on screen.
     * Elementor's editor, in-page-nav pages (_header.scss) and the open off-canvas
     * menu all position the header differently, so leave it alone in those cases.
     */
    #canScrollHide() {
        return this.#topBarHeight > 0
            && !this.$body.hasClass('elementor-editor-active')
            && !this.$body.hasClass('js--hasInPageNav')
            && !this.$html.hasClass('mm-wrapper_opened');
    }

    /**
     * _header.scss moves the header with .scrollHide; _general.scss recomputes
     * --theme--header-height from .js--headerCollapsed. They must never disagree,
     * or every sticky consumer pins to a header position that isn't the real one.
     */
    #setHeaderCollapsed(collapsed) {
        this.$header.toggleClass('scrollHide', collapsed);
        this.$body.toggleClass('js--headerCollapsed', collapsed);
    }

    #updateCssHeaderHeight() {
        if(this.$header && this.$header.length === 0) {
            // If header is not initially set, set it.
            this.$header = $('header.elementor-location-header');
        }

        try {
            // The header's own height, with no admin bar folded in. Deliberately not
            // this.headerHeight: that getter adds #wpadminbar for the document-space
            // scroll offsets that consume it, but both CSS consumers here need the bar
            // kept separate -- #site-wrapper already starts below it (core's
            // html{margin-top}), and --theme--header-height adds it back itself for
            // viewport-relative consumers. Folding it in here double-counts it.
            this.#root.style.setProperty(
                '--theme--header-height--full',
                this.$header.outerHeight() + "px"
            );
            this.#root.style.setProperty('--theme--header-top', (this.$header.position().top + 20) + "px");

            // Native offsetHeight (not jQuery) so a responsively hidden top bar measures 0.
            const $topBar = document.querySelector('.header-top-bar');

            // Round up: the bar's real height is fractional, and truncating leaves a
            // hairline of it on screen once the header slides up.
            this.#topBarHeight = $topBar ? Math.ceil($topBar.getBoundingClientRect().height) : 0;
            this.#root.style.setProperty('--topHeaderHeight', this.#topBarHeight + "px");

            // Measure the admin bar rather than trusting the hardcoded 32/46px,
            // and treat it as zero height once core un-fixes it (<=600px) so the
            // header sits flush. Set on <body>, not :root: the SCSS fallback is
            // declared on body.admin-bar, and the nearest ancestor wins.
            // Query live rather than reusing the constructor's #$admin cache: that
            // cache is populated on a normal page load (headerHeight demonstrably
            // includes the bar), but it is captured once and cannot see the bar being
            // added, removed or un-fixed later, and #wpadminbar is absent when the
            // script runs on a wp_footer-rendered bar.
            const adminBar = document.getElementById("wpadminbar");
            const adminBarFixed = adminBar
                && window.getComputedStyle(adminBar).position === 'fixed';

            document.body.style.setProperty(
                '--adminBarHeight',
                (adminBarFixed ? Math.ceil(adminBar.getBoundingClientRect().height) : 0) + "px"
            );
        } catch (e) {
            Utils.log(e);
        }
    }
}
